import React from "react";

const CircleMemo = ({ color }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13.0766" cy="12.977" r="12.5874" fill={color} />
    </svg>
  );
};

export default CircleMemo;
